import gql from 'graphql-tag';

export default id => gql`
  query {
    getProvSequenceDataSpec(objectType: ${id}) {
      attribute
    }
  }
`;
